var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-item flex column p-20",on:{"click":_vm.goLink}},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data?.title))]),_c('div',{staticClass:"pro"},[_vm._v(_vm._s(_vm.data.author)+" "+_vm._s(_vm.data.author_title))]),_c('div',{staticClass:"image",style:(_vm.imageStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }